import React, { useEffect, useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Lead } from '../../data/mockLeads';
import { OWNERS } from './FilterBar';
import { UserCheck, Check } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ChangeOwnerModalProps {
  lead: Lead | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (leadId: string, newOwner: string) => void;
}
export function ChangeOwnerModal({
  lead,
  open,
  onClose,
  onConfirm
}: ChangeOwnerModalProps) {
  const [selected, setSelected] = useState<string>('');
  useEffect(() => {
    if (open && lead) {
      setSelected(lead.owner);
    }
  }, [open, lead?.id]);
  if (!lead) return null;
  return <Modal open={open} onClose={onClose} title="Change Lead Owner" subtitle={<div className="flex flex-wrap items-center gap-2 text-xs" data-id="element-41">
          <span data-id="element-42">{lead.name}</span>
          <span className="text-slate-300" data-id="element-43">•</span>
          <span data-id="element-44">
            Current owner:{' '}
            <span className="font-medium text-slate-700" data-id="element-45">{lead.owner}</span>
          </span>
        </div>} data-id="element-40">
      <div className="space-y-4" data-id="element-46">
        <div data-id="element-47">
          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2" data-id="element-48">
            Assign To
          </label>
          <div className="space-y-2" data-id="element-49">
            {OWNERS.map(o => {
            const isActive = selected === o;
            const isQueue = o === 'Round Robin Queue';
            return <button key={o} type="button" onClick={() => setSelected(o)} className={cn('w-full flex items-center gap-3 px-3 py-2.5 rounded-lg border text-left transition-colors', isActive ? 'border-indigo-500 bg-indigo-50/60 ring-1 ring-indigo-200' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50')} data-id="element-50">
                  <span className={cn('inline-flex h-4 w-4 items-center justify-center rounded-full border', isActive ? 'bg-indigo-600 border-indigo-600 text-white' : 'bg-white border-slate-300')} aria-hidden="true" data-id="element-51">
                    {isActive && <Check className="w-3 h-3" strokeWidth={3} data-id="element-52" />}
                  </span>
                  <span className={cn('text-sm font-medium', isQueue ? 'text-amber-700' : 'text-slate-900')} data-id="element-53">
                    {o}
                  </span>
                  {isQueue && <span className="ml-auto text-xs text-slate-400" data-id="element-54">
                      Unassigned · waiting for routing
                    </span>}
                </button>;
          })}
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-200" data-id="element-55">
          <Button variant="ghost" onClick={onClose} data-id="element-56">
            Cancel
          </Button>
          <Button variant="primary" disabled={!selected || selected === lead.owner} onClick={() => {
          if (selected) {
            onConfirm(lead.id, selected);
            onClose();
          }
        }} data-id="element-57">
            <UserCheck className="w-4 h-4 mr-1.5" data-id="element-58" />
            Assign
          </Button>
        </div>
      </div>
    </Modal>;
}